<ns-grid [loading]="loading"
         rowSelection="multiple"
         [columns]="columns"
         [config]="gridConfig"
         [data]="selectedCustomer?.customerLocations || []"
         (selectedRows)="selectionChange($event)"
>
  <div class="w-100 d-flex justify-content-between form-fields" grid-header>
    <mat-form-field appearance="outline" class="w-25" color="accent">
      <mat-label>select customer</mat-label>
      <mat-select [(ngModel)]="selectedCustomer" (selectionChange)="selectedRows = []" disableOptionCentering>
        <mat-option *ngFor="let customer of data" [value]="customer">{{ customer.customerName + ' - ' + customer.primary6 }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>select Actions</mat-label>
        <mat-select [(ngModel)]="selectedAction" disableOptionCentering>
          <mat-option [value]="commons.DASHBOARD">View Account Summary</mat-option>
          <mat-option [value]="commons.MANAGE">View eManage</mat-option>
          <mat-option [value]="commons.DELIVERY">View eDelivery</mat-option>
        </mat-select>
      </mat-form-field>
      <button class="mx-3" [disabled]="selectedRows.length === 0" mat-flat-button color="accent" (click)="updateLocations()" aria-label="GO">GO
      </button>
    </div>
  </div>
</ns-grid>
